import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { AnalyticsRoutingModule } from '@app/main/analytics/analytics-routing.module';
import { AnalyticsLoaderModule } from '@app/main/analytics/loader-directive/loader.module';
import { AssessmentComponent } from '@app/main/analytics/assessment/assessment.component';
import { AssessmentEditDialogComponent } from '@app/main/apps/forms/assessment/assessment-edit-dialog/assessment-edit-dialog.component';
import { AssessmentCardComponent } from './assessment-card/assessment-card.component';
import { AssessmentReportDialogComponent } from './assessment-report-dialog/assessment-report-dialog.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { AssessmentEditDialogModule } from '@app/main/apps/forms/assessment/assessment-edit-dialog.module';
import { AssessmentReportModule } from './assessment-report/assessment-report.module';
import { UserSearchModule } from '@shared/components/user-search/user-search.module';

@NgModule({
    declarations: [
        AssessmentComponent,
        AssessmentCardComponent,
        AssessmentReportDialogComponent,
    ],
    imports: [
        SharedModule,
        AnalyticsRoutingModule,
        AnalyticsLoaderModule,
        AssessmentEditDialogModule,
        AssessmentReportModule,
        UserSearchModule,
        NgxEchartsModule.forChild(),
    ],
    exports: [
        AssessmentComponent,
        AssessmentEditDialogComponent,
        AssessmentCardComponent,
        AssessmentReportDialogComponent,
    ],
    providers: []
})
export class AssessmentModule { }
